import { FormResult, IMdBody } from '../../../types/shared';

import { InputValue } from '../../organisms/calculator/Calculator.types';

export enum InitialSum {
  ZERO = '€0,00',
}

export interface FormResultProps extends FormResult {
  inputValues: InputValue[];
  placeholder?: string;
  tooltip?: IMdBody;
  theme?: 'default' | 'large';
  valueId: string;
  onCalculate?: (name: string, value: string) => void;
  trackingData?: {
    id: string;
    trackingName: string;
  };
}
